/* eslint-disable */
const localization = {
    // This is the array of lexemes found in the app
    lexemes: [
      "Alles über Freundschaft",
      "Finde neue Freunde mit der Bumble For Friends-App | Bumble",
      "Laden im App Store",
      "Jetzt bei Google Play",
      "Dein Ort, um neue Freunde zu finden",
      "Lern Leute in deiner Nähe kennen, die nach echten Kontakten suchen.",
      "Finde Freunde für jede Lebensphase",
      "Neu in der Stadt? Lust auf einen Neuanfang? Triff deine neuen Besties!",
      "Ein sicherer Ort für alle",
      "Willkommen in der netten Ecke des Internets, in der du du selbst sein kannst.",
      "App downloaden",
      "Triff Leute IRL, die sich für die gleichen Sachen interessieren wie du.",
      "Lern neue Leute in der Gruppe kennen, mit Plans auf Bumble For Friends",
      "Du bist zu Plans eingeladen",
      "Plans ist ein neues Feature auf Bumble For Friends, mit dem du Gruppentreffen mit neuen Freunden in deiner Nähe planen und teilnehmen kannst",
      "Cookies verwalten",
      "Gender Pay Gap",
      "Modern Slavery Statement",
      "Terms and Conditions",
      "About",
      "Life"
],

    // These are the common words found in the lexemes of the app
    common: {
      "day": {
            "plural": [
                  "Tage",
                  "Tage",
                  "Tagen",
                  "Tage"
            ],
            "singular": [
                  "Tag",
                  "Tags",
                  "Tag",
                  "Tag"
            ]
      },
      "hour": {
            "plural": [
                  "Stunden",
                  "Stunden",
                  "Stunden",
                  "Stunden"
            ],
            "singular": [
                  "Stunde",
                  "Stunde",
                  "Stunde",
                  "Stunde"
            ]
      },
      "minute": {
            "plural": [
                  "Minuten",
                  "Minuten",
                  "Minuten",
                  "Minuten"
            ],
            "singular": [
                  "Minute",
                  "Minute",
                  "Minute",
                  "Minute"
            ]
      },
      "month": {
            "plural": [
                  "Monate",
                  "Monate",
                  "Monaten",
                  "Monate"
            ],
            "singular": [
                  "Monat",
                  "Monats",
                  "Monat",
                  "Monat"
            ]
      },
      "second": {
            "plural": [
                  "Sekunden",
                  "Sekunden",
                  "Sekunden",
                  "Sekunden"
            ],
            "singular": [
                  "Sekunde",
                  "Sekunde",
                  "Sekunde",
                  "Sekunde"
            ]
      },
      "year": {
            "plural": [
                  "Jahre",
                  "Jahre",
                  "Jahren",
                  "Jahre"
            ],
            "singular": [
                  "Jahr",
                  "Jahres",
                  "Jahr",
                  "Jahr"
            ]
      }
}
};

// In dev mode we extend lexemes to include the indexMap as well, in production it remains as an array
if (__DEV__) {
    // This is a map of lexeme ids to their index in the array, it's only needed during development
    const indexMap = require('./index-map').default;

    localization.indexMap = indexMap;

    Object.entries(localization.indexMap).forEach(([indexKey, indexValue]) => {
        localization.lexemes[indexKey] = localization.lexemes[indexValue];
    });
}

export default localization;
